/**
 * Created by devpatel on 3/28/14.
 */

"use strict";
var SoaModel = require('bunsen/models/SoaModel');
var ReturnPolicy = module.exports = SoaModel.extend();

var Items = require('bunsen/collections/inventory/Items');
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Seller = require('bunsen/models/Seller.js');

_.extend(ReturnPolicy.prototype, {
    url : function () {
        var url = endpoints.returnPolicy(this.get('id'));
        return url;
    },
    defaults: {
        defaultPolicy: 'N',
        accept : 'N'
    },

    /**
     * Applies current policy to itemIds passed
     * @param itemIdsArray
     * @returns {Deferred}
     */
    saveForItems: function (itemIdsArray) {
        var dfd = new $.Deferred();
        this.saveWithQueryParameters(null, {
            url: endpoints.itemsReturnPolicy(),
            queries: {
                newReturnPolicyId: this.get('id'),
                itemId: itemIdsArray.join()
            }
        }).done(function () {
            dfd.resolve();
        }).fail(function () {
            dfd.reject('replace');
        });
        return dfd;
    },

    /**
     * Delete this return policy and replace all items with the passed in return policy
     * @param replaceWith
     */
    replaceAndDelete: function (replaceWith) {
        var dfd = new $.Deferred();
        var self = this;
        this.saveWithQueryParameters(null, {
            url: endpoints.itemsReturnPolicy(),
            queries: {
                oldReturnPolicyId: this.get('id'),
                newReturnPolicyId: replaceWith.get('id')
            }
        }).done(function () {
            //another call to actually delete policy
            self.destroy().done(function () {
                dfd.resolve();
            }).fail(function () {
                dfd.reject('delete');
            });
        }).fail(function () {
            dfd.reject('replace');
        });
        return dfd;
    },

    fetchItemsAffected: function () {
        var self = this;
        var dfd = new $.Deferred();
        var items = new Items();
        var sellerIds = Seller.getCurrentSeller().get('id');

        items.fetch({
            data: {
                sellerIds: sellerIds,
                pageSize: 0,
                returnPolicyIds: this.get('id'),
                returnTotalResults: true
            }
        }).done(function (data) {
            self.itemsAffected = data.totalResults;
            dfd.resolve();
        }).fail(function () {
            dfd.reject();
        });
        return dfd;
    },

    acceptsReturns: function () {
        // === true is for graphql response...
        return this.get('accept') === 'Y' || this.get('accept') === true;
    },

    isDefault: function () {
        return this.get('defaultPolicy') === 'Y';
    }

});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/ReturnPolicy.js
// module id = 321
// module chunks = 64